import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { ClientService } from "src/app/services/clients/client.service";

import { BaseComponent } from "../../base.component";
@Component({
  selector: "app-cb-move-template-modal",
  templateUrl: "./cb-move-template-modal.component.html",
  styleUrls: ["./cb-move-template-modal.component.scss"],
})
export class CBMoveTemplateModal extends BaseComponent implements OnInit {
  @Input() modalData: any[] = [];
  @Input() modalTitle: string = "";
  @Input() preSelectedIds: number;
  @Input() templateId: number;
  @Input() currentJourneyData: {
    theme_ids: number[];
    templateID: number;
    companyID: number;
  };
  @Input() isMoveModalOpen: boolean = false;
  @Output() refreshTemplateList = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();
  selectedThemeIds: number[] = [];
  companyID: number;
  templateID: number;
  searchText: string = "";
  filteredData: any[] = [];

  constructor(
    private spinner: NgxSpinnerService,
    private clientService: ClientService,
  ) {
    super();
  }

  ngOnInit() {}
  ngOnChanges() {
    this.selectedThemeIds = this.currentJourneyData?.theme_ids || [];
    if (this.modalData != null && this.modalData.length > 0) {
      this.markPreselected();
    }
    this.filteredData = JSON.parse(JSON.stringify(this.modalData));
  }
  closeModal() {
    this.closed.emit();
  }

  toggleAccordion(node: any) {
    node.open = !node.open;
  }

  toggleNode(node: any, checked: boolean) {
    node.checked = checked;
    node.indeterminate = false;

    if (node.children?.length) {
      node.children.forEach((child: any) => this.toggleNode(child, checked));
    }
  }

  onChildCheck(child: any) {
    const id = Number(child.id); // normalize type

    if (child.checked) {
      if (!this.selectedThemeIds.includes(id)) {
        this.selectedThemeIds = [...this.selectedThemeIds, id];
      }
    } else {
      this.selectedThemeIds = this.selectedThemeIds.filter((x) => x !== id);
    }
  }

  markPreselected() {
    const ids = this.currentJourneyData.theme_ids;

    this.modalData.forEach((parent) => {
      parent.children?.forEach((child: any) => {
        child.checked = ids.includes(Number(child.id));
      });
    });
  }
  updateParent(node: any, parent?: any) {
    if (!parent || !parent.children?.length) return;

    const allChecked = parent.children.every((c: any) => c.checked);
    const someChecked = parent.children.some(
      (c: any) => c.checked || c.indeterminate,
    );

    parent.checked = allChecked;
    parent.indeterminate = !allChecked && someChecked;
  }

  onCheck(node: any, parent?: any) {
    this.toggleNode(node, node.checked);
    this.updateParent(node, parent);
  }

  filterTree() {
    const text = this.searchText.toLowerCase();

    if (!text) {
      this.filteredData = JSON.parse(JSON.stringify(this.modalData));
      return;
    }

    this.filteredData = this.modalData
      .map((parent) => {
        const matchedChildren = parent.children?.filter((child: any) =>
          child.name.toLowerCase().includes(text),
        );

        if (
          parent.name.toLowerCase().includes(text) ||
          matchedChildren?.length
        ) {
          return {
            ...parent,
            open: true,
            children: matchedChildren || [],
          };
        }

        return null;
      })
      .filter(Boolean);
  }
  submitMove() {
    this.saveMoveTemplate();
  }

  async saveMoveTemplate() {
    const payload = {
      company_id: this.currentJourneyData.companyID,
      template_id: this.currentJourneyData.templateID,
      theme_ids: this.selectedThemeIds,
    };
    this.spinner.show();

    this.clientService.moveTemplates(payload).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          this.toastrService.success(res.message);
          this.refreshTemplateList.emit();
          this.closed.emit();
        }
      },
      error: (err) => {
        this.spinner.hide();
        this.toastrService.error("Something went wrong while save template.");
      },
    });
  }
}
